module.exports = __webpack_public_path__ + "static/media/promo.6fb01a9e.png";